import { fortuneDoubleColors } from '@/constants/fortune-double/colors';
import { useGameButton } from '@/hooks/games/useGameButton';
import { RootState } from '@/lib/store';
import { BetStatusId } from '@/models/bet/status/id';
import { RouletteColor } from '@/models/roulette/color';
import { Button, ErrorChip } from '@starsoft/common/components';
import { memo, MouseEvent, PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import GameButtonChip from './Chip';
import { GameButtonProps } from './props';
import styles from './styles.module.scss';

function GameButton({
  bet,
  isOpen,
  loading,
  onClick,
  children,
  disabled,
  isTransparent,
  isCustomStyles,
  visible = true,
  disableAnimation,
  color = RouletteColor.White,
  isSkeleton,
  error,
  isSecondary = false,
  refetch,
  ...props
}: PropsWithChildren<GameButtonProps>) {
  const { isError, onClick: handleGameButtonClick } = useGameButton();
  const animate = useSelector(
    (state: RootState) => state.gamePreferences.animate,
  );

  function handleClick(e: MouseEvent<HTMLButtonElement>) {
    handleGameButtonClick(bet, () => onClick(e));
  }

  if (!visible) {
    return <div />;
  }

  if (error && refetch) {
    return <ErrorChip action={refetch} />;
  }

  return (
    <div className={styles.wrapper}>
      {!disableAnimation && animate && <GameButtonChip />}
      <Button
        isSecondary={isSecondary}
        className={`${styles.button} ${isCustomStyles && color ? styles['button--custom'] : ''} ${bet?.status?.status?.id?.toString() === BetStatusId.Open?.toString() ? styles['button--active-bet'] : ''} ${isTransparent ? styles['button--transparent'] : ''}`}
        color={color}
        disabled={(isError && !isOpen) || disabled || loading}
        onClick={handleClick}
        isloading={loading}
        isSkeleton={isSkeleton}
        style={
          isCustomStyles && color
            ? {
                backgroundImage: `url(${
                  process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL
                }/artworks/fortune-double/backgrounds/${color.toLocaleLowerCase()}/button.png)`,
                backgroundColor: fortuneDoubleColors.get(color),
              }
            : {}
        }
        {...props}
      >
        {children}
      </Button>
    </div>
  );
}

export default memo(GameButton);
